const FIELD_CONFIG = {
  equipment: [
    ['name', 'Ad / Tip'],
    ['equipment_code', 'Kod'],
    ['category', 'Kategori', 'category_label'],
    ['area', 'Alan'],
    ['location_detail', 'Konum Detayı'],
    ['temperature', 'Sıcaklık'],
    ['brand', 'Marka'],
    ['model_name', 'Model'],
    ['notes', 'Not'],
    ['is_active', 'Aktif'],
  ],
  maintenance_records: [
    ['equipment', 'Ekipman', 'equipment_name'],
    ['title', 'Başlık'],
    ['maintenance_type', 'Bakım Tipi', 'maintenance_type_label'],
    ['status', 'Durum', 'status_label'],
    ['scheduled_date', 'Plan Tarihi'],
    ['completed_date', 'Tamamlanma Tarihi'],
    ['performed_by', 'Bakımı Yapan'],
    ['vendor', 'Firma'],
    ['next_maintenance_date', 'Sonraki Bakım'],
    ['description', 'Açıklama - Yapılan İş'],
    ['cost', 'Açıklama - Tutar (TRY)'],
  ],
  maintenance_invoices: [
    ['invoice_no', 'Fatura No'],
    ['invoice_date', 'Tarih'],
    ['supplier', 'Tedarikçi'],
    ['invoice_type', 'Fatura Tipi', 'invoice_type_label'],
    ['subtotal', 'Ara Toplam'],
    ['vat_amount', 'KDV Tutarı'],
    ['total_amount', 'Genel Toplam'],
    ['payment_status', 'Ödeme Durumu', 'payment_status_label'],
    ['notes', 'Not'],
  ],
};

const parsePayload = (raw) => {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'object') return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const normalize = (value) => {
  if (value == null) return null;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed || null;
  }
  if (typeof value === 'boolean') return value;
  return value;
};

const valuesEqual = (oldVal, newVal) => {
  const a = normalize(oldVal);
  const b = normalize(newVal);
  if (a == null && b == null) return true;
  if (a == null || b == null) return false;
  const aNum = Number(a);
  const bNum = Number(b);
  if (!Number.isNaN(aNum) && !Number.isNaN(bNum) && String(a).trim() !== '' && String(b).trim() !== '') {
    return aNum === bNum;
  }
  return String(a) === String(b);
};

const fieldValue = (data, key, displayKey) => {
  if (!data) return null;
  if (displayKey) {
    const display = data[displayKey];
    if (display != null && display !== '') return display;
  }
  return data[key];
};

const normalizeInvoiceLines = (lines) => {
  if (!Array.isArray(lines)) return [];
  return lines.map((line) => JSON.stringify({
    equipment: line?.equipment ?? null,
    description: (line?.description || '').trim(),
    quantity: line?.quantity ?? null,
    unit_price: line?.unit_price ?? null,
    amount: line?.amount ?? null,
  }));
};

const invoiceLinesChanged = (oldData, newData) => {
  const oldLines = normalizeInvoiceLines(oldData?.lines);
  const newLines = normalizeInvoiceLines(newData?.lines);
  return oldLines.join('|') !== newLines.join('|');
};

const diffFields = (tableName, oldData, newData) => {
  const config = FIELD_CONFIG[tableName] || [];
  const changes = [];
  config.forEach(([key, label, displayKey]) => {
    const oldVal = fieldValue(oldData, key, displayKey);
    const newVal = fieldValue(newData, key, displayKey);
    if (valuesEqual(oldVal, newVal)) return;
    changes.push(`${label} değişti`);
  });
  return changes;
};

export const computeAuditChanges = (tableName, action, oldValue, newValue) => {
  const oldData = parsePayload(oldValue);
  const newData = parsePayload(newValue);

  if (action === 'INSERT') return [];
  if (action === 'DELETE') return ['Kayıt silindi'];
  if (action !== 'UPDATE' || !oldData || !newData) return [];

  const changes = diffFields(tableName, oldData, newData);
  if (tableName === 'maintenance_invoices' && invoiceLinesChanged(oldData, newData)) {
    changes.push('Fatura Kalemleri değişti');
  }
  return changes;
};
